import React, { useState, useEffect } from 'react'
import {
	Box,
	Text,
	IconButton,
	Icon,
	Flex,
	Center,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerOverlay,
	DrawerHeader,
	Button,
	DrawerFooter,
	useDisclosure,
	Divider,
	CircularProgress,
	CircularProgressLabel,
} from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import FormPanel from './index'
import SmarFormPanel from './smart-form-panel'
import { SmartFormContextProvider } from '../../context/smart-form.context'
import { sectionDetailedTrack } from '../repository/repo.utils'
import { GA_CATEGORY_FORM_MANAGEMENT } from './../repository/repo.utils'
import bgImage from '../../assets/images/opaque_bgImage.png'
const view = {
	CATEGORY_SELECTOR: 'CATEGORY_SELECTOR',
	ORIGIN_FORM: 'ORIGIN_FORM',
	ERROR_VIEW: 'ERROR_VIEW',
}

const OriginFormPanel = ({
	panelV,
	onClose, ///TODO: On close should ask the user with modal popup with text as your progress will be lost, are you sure?
	from = '',
}) => {
	const [panelView, setpanelView] = useState(view.CATEGORY_SELECTOR)
	const [selectedForm, setSelectedForm] = useState(null)
	const {
		isOpen: isOpenDrawer,
		onOpen,
		onClose: onCloseOpenDrawer,
	} = useDisclosure()
	useEffect(() => onOpen())
	return (
		<Box
			position='relative'
			h='calc(100vh - 90px)'
			bg='white'
			borderRadius='md'
		>
			{view.ORIGIN_FORM === panelView ? null : ''}
			{panelView === view.CATEGORY_SELECTOR ? (
				<FormPanel
					onFormSelect={data => {
						setpanelView(view.ORIGIN_FORM)
						setSelectedForm(data)
					}}
					from={from}
					panelV={panelV}
					onClose={onClose}
				/>
			) : panelView === view.ERROR_VIEW ? (
				<Box p={4}>
					<Center>
						<Text> Opps something went wrong please try after some time!</Text>
						<Button
							onClick={() => {
								sectionDetailedTrack({
									category: GA_CATEGORY_FORM_MANAGEMENT,
									action: 'Origin Form Panel',
									label: 'Error Message',
								})
								setpanelView(view.ORIGIN_FORM)
							}}
						>
							Okay
						</Button>
					</Center>
				</Box>
			) : (
				<SmartFormContextProvider>
					<SmarFormPanel
						isOrigin={true}
						onClose={d => {
							if (d && d.activity_id) {
								onClose(d)
							} else {
								setpanelView(view.CATEGORY_SELECTOR)
							}
						}}
						formData={{ ...selectedForm, activity_id: 0 }}
						handleError={() => {
							setpanelView(view.ERROR_VIEW)
						}}
					/>
				</SmartFormContextProvider>
			)}
		</Box>
	)
}

export default OriginFormPanel
